import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=4ebdd5f0&scoped=true&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"
import style0 from "./Versions.vue?vue&type=style&index=0&id=4ebdd5f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebdd5f0",
  null
  
)

export default component.exports